import PropTypes from 'prop-types';

export const propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  slug: PropTypes.string,
  title: PropTypes.string,
  required: PropTypes.bool
};

export const defaultProps = {
  id: null,
  type: null,
  slug: null,
  title: null,
  required: false
};

export default { defaultProps, propTypes };
